// generated by genversion
export const version = '1.5.2';
//# sourceMappingURL=version.js.map